import React from 'react';
import { Row } from 'reactstrap';
import language from '../../../../assets/languages/language';
import { renderHTMLContent } from '../../../../common/function';

function ViewNormalQuestionChoices(props) {
  const { optionsArr, userChoice, selectedCaseQuestionData } = props;
  return (
    <Row>
      {' '}
      {optionsArr.map((item, index) => {
        return (
          <div className='col-sm-12' id={item} key={index}>
            <div
              className={`answer_box cursor-default ${userChoice
                ? selectedCaseQuestionData &&
                  (selectedCaseQuestionData.answer === item ||
                    item === `choice_${selectedCaseQuestionData.answer}`) &&
                  userChoice[selectedCaseQuestionData.id] === item
                  ? `border-green`
                  : selectedCaseQuestionData.answer === item ||
                    item === `choice_${selectedCaseQuestionData.answer}`
                    ? 'border-green'
                    : userChoice[selectedCaseQuestionData.id] === item
                      ? 'border-red'
                      : ''
                : ''
                }`}
            >
              <div className='answer_count highlight_choice'>
                {item === 'choice_a'
                  ? language.LC().A
                  : item === 'choice_b'
                    ? language.LC().B
                    : language.LC().C}
              </div>
              <p className={`ans_box_text`}>
                {selectedCaseQuestionData && selectedCaseQuestionData[item] ? (
                  renderHTMLContent(
                    selectedCaseQuestionData[item],
                    "span",
                    "",
                    { contentEditable: false }
                  )
                ) : null}
              </p>
            </div>
          </div>
        );
      })}
    </Row>
  );
}

export default ViewNormalQuestionChoices;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/FinishTest/ViewNormalQuestionChoices.jsx